import React from "react";
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { RolesContext } from "../../context/User";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";

const HospitalHomePage = () => {
  const navigate = useNavigate();
  const [stateroles] = useContext(RolesContext);

  const getWelcomeMessage = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "בוקר טוב";
    if (hour < 18) return "צהריים טובים";
    return "ערב טוב";
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100%",
        flex: 1,
        backgroundColor: "#f5f7fa",
        padding: { xs: 2, md: 4 },
      }}
    >
      <Card
        sx={{
          maxWidth: 600,
          width: "100%",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          borderRadius: 3,
          textAlign: "center",
        }}
      >
        <CardContent sx={{ padding: { xs: 3, md: 5 } }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 3,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#e8f5e9",
                borderRadius: "50%",
                padding: 3,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <LocalHospitalIcon sx={{ fontSize: 80, color: "#2e7d32" }} />
            </Box>
          </Box>

          <Typography
            variant="h4"
            sx={{
              fontFamily: "'Varela Round', sans-serif",
              fontWeight: 600,
              color: "#1a237e",
              marginBottom: 1,
            }}
          >
            {getWelcomeMessage()}
          </Typography>

          <Typography
            variant="h5"
            sx={{
              fontFamily: "'Varela Round', sans-serif",
              color: "#424242",
              marginBottom: 1,
            }}
          >
            ברוכים הבאים לפורטל בית חולים
          </Typography>

          {stateroles?.siteLabel && (
            <Typography
              variant="h6"
              sx={{
                fontFamily: "'Varela Round', sans-serif",
                color: "#2e7d32",
                fontWeight: 600,
                marginBottom: 4,
              }}
            >
              {stateroles.siteLabel}
            </Typography>
          )}

          <Button
            variant="contained"
            size="large"
            onClick={() => navigate("/chemo")}
            startIcon={<MedicalServicesIcon />}
            sx={{
              backgroundColor: "#2e7d32",
              color: "white",
              fontSize: "1.2rem",
              padding: "12px 40px",
              borderRadius: 2,
              textTransform: "none",
              fontFamily: "'Varela Round', sans-serif",
              boxShadow: "0 4px 12px rgba(46,125,50,0.3)",
              "&:hover": {
                backgroundColor: "#1b5e20",
                boxShadow: "0 6px 16px rgba(46,125,50,0.4)",
              },
            }}
          >
            כניסה לרשומות כימותרפיה
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default HospitalHomePage;
